var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loanable-calendar',{staticClass:"loan-card loan-loanable-calendar p-0 styled-calendar-card",attrs:{"default-view":"week","events":_vm.allEvents,"month-day-detail":"","availability-mode":"available","initial-date":_vm.loanEvent.start,"loading":_vm.loading},on:{"ready":_vm.fetchEvents,"view-change":_vm.fetchEvents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }